import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  update: false,
  stadiums: [],
  fetchLoading: false,
  singleStadium: null,
};

const slice = createSlice({
  name: "stadium",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // START LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },
    // UPDATE EVENT
    updateStadiumSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.stadiums = state.stadiums.map((stadium) => {
        if (stadium.id === action.payload.id) {
          return action.payload;
        }
        return stadium;
      });
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.update = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getStadiumSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.stadiums = action.payload;
    },

    // GET SINGLE SUCCESS
    getSingleStadiumSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.singleStadium = action.payload;
    },

    // GET PRODUCTS
    createStadiumSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.stadiums = [...state.stadiums, action.payload];
    },

    // DELETE EVENT
    deleteStadiumSuccess(state, action) {
      const stadiumId = action.payload;
      state.stadiums = state.stadiums.filter(
        (stadium) => stadium.id !== stadiumId
      );
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
});

export default slice.reducer;

export function getStadiums() {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get("stadiums");
      dispatch(slice.actions.getStadiumSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSingleStadium({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`stadiums/${id}`);
      dispatch(slice.actions.getSingleStadiumSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createStadium({ data, enqueueSnackbar, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("stadiums", data);
      dispatch(slice.actions.createStadiumSuccess(response.data.data));
      enqueueSnackbar("Stadium is added successfully");
      navigate(-1);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateStadium({ id, data, enqueueSnackbar, setOpenEdit }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`stadiums/${id}`, data);
      dispatch(slice.actions.updateStadiumSuccess(response.data.data));
      enqueueSnackbar("Stadium is updated successfully");
      setOpenEdit(false);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteStadium({ id, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`stadiums/${id}`);
      dispatch(slice.actions.deleteStadiumSuccess(id));
      enqueueSnackbar("Stadium is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
